const DEFAULT_LOCALE = 'en-US'

const LOCALES = [
  {
    lang: 'en-US',
    default: true,
    contentfulLanguage: 'en-US',
  },
  {
    lang: 'ja',
    default: false,
    contentfulLanguage: 'ja',
  },
  {
    lang: 'es',
    default: false,
    contentfulLanguage: 'en-US',
  },
  {
    lang: 'de',
    default: false,
    contentfulLanguage: 'en-US',
  },
  {
    lang: 'fr',
    default: false,
    contentfulLanguage: 'en-US',
  },
  {
    lang: 'tr',
    default: false,
    contentfulLanguage: 'en-US',
  },
  {
    lang: 'pt',
    default: false,
    contentfulLanguage: 'en-US',
  },
]

module.exports.DEFAULT_LOCALE = DEFAULT_LOCALE
module.exports.LOCALES = LOCALES
